/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSmartAccountContext } from "../context/SmartAccountContext/SmartAccountContext";
import { useWeb3AuthContext } from "../context/SocialLoginContext/SocialLoginContext";
import { useGlobalContext } from "../context/GlobalContext/GlobalContext";
import { ellipseAddress } from "../utils";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon, ArrowLeftIcon } from "@heroicons/react/20/solid";
import { ArrowTopRightOnSquareIcon, ArrowLeftOnRectangleIcon, Square2StackIcon, UserCircleIcon } from "@heroicons/react/24/outline";

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

export default function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const { connect, disconnect } = useWeb3AuthContext();
  const { queryParams }: any = useGlobalContext();
  const { selectedAccount, setSelectedAccount }: any = useSmartAccountContext();

  const disconnectWallet = () => {
    disconnect();
    setSelectedAccount(null);
  };

  const goBack = () => {
    return navigate("/");
  };

  let initialTitle = "Stake Crypto";

  const [title, setTitle] = useState("");
  const { pathname } = location;

  useEffect(() => {
    if (pathname === "/wallet") setTitle("My Wallet");
    if (pathname === "/") setTitle(initialTitle);
  }, [pathname]);

  useEffect(() => {
    if (queryParams && queryParams.widgetTitle) initialTitle = queryParams.widgetTitle;
    setTitle(initialTitle);
  }, [queryParams]);

  return (
    <section className="w-full px-8 text-gray-700 bg-white">
      <div className="container  justify-between py-2 mx-auto md:flex-row max-w-7xl">
        <div className="flex mt-2">
          <div className="flex-1 w-64 font-medium text-gray-900 lg:w-auto flex">
            {pathname !== "/" && (
              <button onClick={() => goBack()}>
                <ArrowLeftIcon className="mr-3 mb-2 hidden h-5 w-5 flex-shrink-0 text-gray-800 lg:block" aria-hidden="true" />
              </button>
            )}
            {title && <p className="text-gray-700 mt-0 text-xl font-bold">{title}</p>}
          </div>
          <div className="flex-1 w-64 font-medium text-gray-900 lg:w-auto items-end flex flex-col pb-0 mt-0	">
            {!selectedAccount && (
              <button
                disabled={selectedAccount && selectedAccount.smartAccountAddress ? true : false}
                onClick={connect}
                className="flex w-32 justify-center rounded-md border border-transparent bg-gray-900 py-1 px-0 text-base font-medium text-white shadow hover:bg-black focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-rose-500">
                Connect Wallet
              </button>
            )}
            {selectedAccount && selectedAccount.smartAccountAddress && (
              <div className="flex-none justify-end mr-0">
                <Menu as="div" className="relative">
                  <div>
                    <Menu.Button className="flex max-w-xs items-center rounded-full bg-white text-sm focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2 lg:rounded-md lg:p-2 lg:hover:bg-gray-50">
                      <span className="ml-3 hidden text-sm font-medium text-gray-700 lg:block">
                        <span className="sr-only">Open user menu for </span>
                        {ellipseAddress(selectedAccount.smartAccountAddress, 12)}
                      </span>
                      <ChevronDownIcon className="ml-1 hidden h-5 w-5 flex-shrink-0 text-gray-400 lg:block" aria-hidden="true" />
                    </Menu.Button>
                  </div>
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-200"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95">
                    <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <Menu.Item>
                        {({ active }) => (
                          <Link to="/wallet" className={classNames(active ? "bg-gray-100" : "", "px-4 py-2 text-sm text-gray-700 flex")}>
                            <UserCircleIcon height={18} className="mt-1" />
                            <span className="ml-3 mt-1">My Wallet</span>
                          </Link>
                        )}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            onClick={() => navigator.clipboard.writeText(selectedAccount.smartAccountAddress)}
                            className={classNames(active ? "bg-gray-100" : "", "px-4 py-2 text-sm text-gray-700 flex w-full")}>
                            <Square2StackIcon height={18} className="mt-1" />
                            <span className="ml-3 mt-1">Copy Address</span>
                          </button>
                        )}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (
                          <a
                            href={`https://mumbai.polygonscan.com/address/${selectedAccount.smartAccountAddress}`}
                            target="_blank"
                            rel="noreferrer"
                            className={classNames(active ? "bg-gray-100" : "", "px-4 py-2 text-sm text-gray-700 flex")}>
                            <ArrowTopRightOnSquareIcon height={18} className="mt-1" />
                            <span className="ml-3 mt-1">View on Explorer</span>
                          </a>
                        )}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (
                          <button onClick={disconnectWallet} className={classNames(active ? "bg-gray-100" : "", "px-4 py-2 text-sm text-gray-700 flex w-full")}>
                            <ArrowLeftOnRectangleIcon height={18} className="mt-1" />
                            <span className="ml-3 mt-1">Disconnect</span>
                          </button>
                        )}
                      </Menu.Item>
                    </Menu.Items>
                  </Transition>
                </Menu>
              </div>
            )}
          </div>
        </div>
        <div className="relative mt-1">
          <div className="absolute inset-0 flex items-center" aria-hidden="true">
            <div className="w-full border-t border-gray-300" />
          </div>
          <div className="relative flex justify-center text-sm">
            <span className="bg-white px-2 text-gray-500"></span>
          </div>
        </div>
      </div>
    </section>
  );
}
